
import Vue from "vue";
import dialogCom from "@/components/ModelCom.vue";
import fetchRequest from "@/assets/js/sseUtil";
import CookieUtil from "@/assets/js/CookieUtil";
import { cookieTypes } from "@/assets/js/Types";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import { Marked } from "marked";
import { markedHighlight } from "marked-highlight";
import hljs from "highlight.js";
import "highlight.js/styles/github.css";
import "highlight.js/styles/paraiso-light.css";
export default Vue.extend({
  props: ["title", "content"],
  components: { dialogCom },
  data() {
    return {
      askContent: "" as string,
      think: "" as string,
      con: "" as string,
    };
  },
  methods: {
    open(content: string) {
      const dialog: any = this.$refs.fileDialog;
      dialog.show();
      this.askContent = content;
      this.think = "";
      this.con = "";
      this.engDeepseek1();
    },
    hiden() {
      const dialog: any = this.$refs.fileDialog;
      dialog.hiden();
    },
    markMessage(message: any): any {
      message = message.replaceAll("\\n", "\n");
      // console.log('调用前'+message)
      const marked = new Marked(
        markedHighlight({
          pedantic: false,
          gfm: true, // 开启gfm
          breaks: true,
          smartLists: true,
          xhtml: true,
          async: false, // 如果是异步的，可以设置为 true
          langPrefix: "hljs language-", // 可选：用于给代码块添加前缀
          emptyLangClass: "no-lang", // 没有指定语言的代码块会添加这个类名
          highlight: (code: any) => {
            return hljs.highlightAuto(code).value;
          },
        })
      );
      let markedMessage = marked.parse(message);
      // console.log('调用了'+markedMessage)
      return markedMessage;
    },
    engDeepseek1() {
      fetchRequest.fetchRequest(
        this.askContent,
        Utils.GetGuid(),
        (res: string) => {
          this.think = this.markMessage(res);
          console.log(this.think);
        },
        (res: string) => {
          this.con = this.markMessage(res);
          console.log(this.con);
        },
        (error: string) => {
          throw error;
        }
      );
    },
  },
});
